import { inject, injectable } from 'inversify';
import React from 'react';

import { User } from '@project44/ui-utils';

import { TUseToggleComponentHook } from '../../../../shared/core/infrastructrue/types';
import { TenantHookService } from '../../application/Tenant.hook.service';
import { TUseSwitchTenantHook } from '../../domain';

@injectable()
export class TenantHookController {
  constructor(
    @inject(TenantHookService)
    private readonly tenantHookService: TenantHookService,
  ) {}

  public composeUseToggleTenantSwitcherComponent(payload: {
    user?: User;
    passThroughComponent?: React.ReactElement<unknown>;
  }): TUseToggleComponentHook {
    return this.tenantHookService.composeUseToggleTenantSwitcherComponent(
      payload,
    );
  }

  public composeUseSwitchTenantHook(): TUseSwitchTenantHook {
    return this.tenantHookService.composeUseSwitchTenantHook();
  }
}
